export class rootModel{
     
  
    language:string = 'tr';
    jou_uid:string="d32275f4-f952-4966-9dfb-8f5164c6f976";
    cat_id:string;
    result:string;
    page_id:string;

}